import { DefaultFilterNum } from "./constants";
import { FilterFormValues, FilterOperation, FilterValueType } from "./types";

export const getOperationLabelMappings = (
  t: (key: string, _default: string) => string,
): Record<FilterOperation, string> => ({
  contains: t("common.label.contains", "Contains"),
  not_contains: t("common.label.notContains", "Not Contains"),
  equals: t("common.label.equals", "Equals"),
  not_equals: t("common.label.notEquals", "Not Equals"),
  begins_with: t("common.label.beginsWith", "Begins With"),
  not_begins_with: t("common.label.notBeginsWith", "Not Begins With"),
  ends_with: t("common.label.endsWith", "Ends With"),
  not_ends_with: t("common.label.notEndsWith", "Not Ends With"),
  greater_than: t("common.label.greaterThan", "Greater Than"),
  greater_than_or_equals: t(
    "common.label.greaterThanOrEquals",
    "Greater Than or Equals",
  ),
  less_than: t("common.label.lessThan", "Less Than"),
  less_than_or_equals: t(
    "common.label.lessThanOrEquals",
    "Less Than or Equals",
  ),
  between: t("common.label.between", "Between"),
  on_or_before: t("common.label.onOrBefore", "On or Before"),
  on_or_after: t("common.label.onOrAfter", "On or After"),
});

export const getInitialFormValues = (
  initialValue:
    | (Omit<FilterFormValues, "operation"> & {
        operation: FilterOperation | undefined;
      })
    | undefined,
  filterOperations: readonly FilterOperation[],
  maxLength: number = DefaultFilterNum,
) => {
  return {
    operation: initialValue?.operation ?? filterOperations[0],
    values: Array.from({ length: maxLength }, (_, i) => {
      const value = initialValue?.values[i];
      if (value == null) return ["", ""];
      if (Array.isArray(value)) return [value[0] ?? "", value[1] ?? ""];
      return [value, ""];
    }),
  };
};

export const getMaxIndex = (
  fields: any[],
  filterType: string,
  maximum: number = DefaultFilterNum,
) => {
  if (filterType === "between") return 0;

  const emptyIndex = fields.findIndex((value: any[]) =>
    value.every((v) => v === ""),
  );

  return emptyIndex === -1 ? maximum - 1 : emptyIndex;
};

export const sanitizeValues = (
  formValues: FilterFormValues,
  type?: FilterValueType,
) => {
  let values: any[];
  if (formValues.operation === "between") {
    if (type === "datetime") {
      values = formValues.values
        .map((value: any[]) =>
          [...value].sort(
            (a, b) => new Date(a).getTime() - new Date(b).getTime(),
          ),
        )
        .filter((value: any[]) => value.every((v) => !!v));
    } else {
      values = formValues.values
        .map((value: any[]) =>
          value.map((v) => Number.parseFloat(v)).toSorted((a, b) => a - b),
        )
        .filter((value) => value.every((v) => !Number.isNaN(v)));
    }
  } else {
    values = formValues.values
      .map((value) =>
        typeof value[0] === "string" ? value[0].trim() : value[0],
      )
      .filter((value) => !!value);
  }
  return { ...formValues, values };
};
